import styled, {css} from 'styled-components'

export const StyledListItems = styled.div`
    ${({theme: {spacing, sizing}}) => css`
        padding: ${spacing * 2}px;
        min-height: ${`calc(100% - ${sizing.headerMobileHeight} - 80px)`};
    `}
`
